import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_REQUEST_SUPPRESSION').plugin(axiosPlugin);

let RequestSuppressionAction = redux.fetchActionUpdate();
let RequestSuppressionActionGet = redux.fetchActionGet();

export const requestSuppressionUser = (userId, data = {}) => RequestSuppressionAction(`/users/${userId}/request-suppression`, data);
export const cancelRequestSuppressionUser = (userId) => RequestSuppressionActionGet(`/users/${userId}/cancel-request-suppression`);

export const requestSuppressionAccount = redux.reducer();